import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check-circle-half",
  "use": "icon-check-circle-half-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-check-circle-half\"><path fill=\"#5ab300\" fill-rule=\"evenodd\" d=\"M28 16c0 6.6-6.644 12-12 12q-.02-8.14 0-11.776V4c6.6 0 12 5.4 12 12M16 2C8.2 2 2 8.2 2 16s6.2 14 14 14 14-6.2 14-14S23.8 2 16 2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol